import { Controller } from "@hotwired/stimulus"

// "Standard für" grid of the Textbaustein form: a default slot (document type ×
// position) is only selectable when the block applies to it — its Verwendung
// covers the position and the document type is ticked. Disabled cells are
// unchecked so they never get submitted; the model releases such slots anyway.
export default class extends Controller {
  static targets = ["usage", "documentType", "slot"]

  connect() {
    this.refresh()
  }

  refresh() {
    const usage = this.usageTargets.find((radio) => radio.checked)?.value || "intro"
    const positions = usage === "both" ? ["intro", "closing"] : [usage]
    const documentTypes = this.documentTypeTargets
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => checkbox.value)

    this.slotTargets.forEach((slot) => {
      const applicable =
        positions.includes(slot.dataset.position) &&
        documentTypes.includes(slot.dataset.documentType)
      slot.disabled = !applicable
      if (!applicable) slot.checked = false
    })
  }
}
